import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import { FormGroupLabel } from '../FormGroupLabel';
var TextArea = function (_a) {
    var onChange = _a.onChange, helpText = _a.helpText, value = _a.value, className = _a.className, placeholder = _a.placeholder, required = _a.required, name = _a.name, label = _a.label, disabled = _a.disabled, size = _a.size, feedback = _a.feedback, valid = _a.valid, invalid = _a.invalid, id = _a.id, isRounded = _a.isRounded;
    return (React.createElement(FormGroupLabel, { feedback: feedback, isRounded: isRounded, helpText: helpText, isRequired: required, className: className, label: label, invalid: invalid, valid: valid },
        React.createElement(TextareaAutosize, { id: id, name: name, value: value !== null && value !== void 0 ? value : '', className: 'gr-textarea custom-scroll ' +
                (size ? size : 'lg') +
                (isRounded ? ' round ' : '') +
                (valid ? 'valid ' : '') +
                (invalid ? 'invalid' : ''), required: required, disabled: disabled, onChange: function (evt) {
                onChange(evt.target.value);
            }, placeholder: placeholder })));
};
export { TextArea };
//# sourceMappingURL=TextArea.js.map